export function cityFormat(address, numberOfInfo = 2) {
  let city = "";
  if (address && address.admin3) {
    city += `${address.admin3.replace("Comune di ", "")}`;
  } else if (address && address.admin2) {
    city += `${address.admin2}`;
  } else if (address && address.admin1) {
    city += `${address.admin1}`;
  }
  if (address && address.city && city !== `${address.city}`) {
    if (numberOfInfo === 2 && city !== "") {
      city += `, ${address.city}`;
    } else if (city === "") {
      city += `${address.city}`;
    }
  }
  return city;
}
